import React from 'react'
import { connect } from 'react-redux'
import SEOTitle from '@chegg-wt/core/components/SEOTitle'
import { useRouter } from 'next/router'
import SourceTypeSelection from '@chegg-wt/core/components/Layouts/SourceTypeSelection'
import { TopContentWrapper } from '@chegg-wt/core/components/AdFrame/'
import SourceTypeSelectionTop from '@chegg-wt/core/components/SourceTypeSelectionTop'
import { NextPageContext } from 'next'
import { getUrlStyleNameV2 } from '@chegg-wt/core/api/oneGraph'
import {
  getActualStyleId,
  getCapitalizedSEONameOfStyle,
  isStyleIdInValid,
} from '@chegg-wt/core/utils/styles'
import { getLvpLayout } from '@chegg-wt/core/components/Layouts/LargeVideoPlayerLayout'
import { NextPageWithLayout, SSRProps } from '@chegg-wt/core/types/layout'
import { Config } from '@chegg-wt/core/config'
import { lvpLayoutSelector } from '@chegg-wt/core/state/featureFlags/selectors'
import { AppState } from '@chegg-wt/core/state'
import { useOnUnloadTimeOnPage } from '@chegg/time-on-page'
import { flankerDesignUpgradeCopy } from '../../copy/upgrade'
import { sourcePageCredibility } from '../../copy/credibility'

interface Props extends SSRProps {
  isLvp: boolean
}
const SourceSelectionPage: NextPageWithLayout<Props> = ({ isLvp, ...ssrProps }) => {
  const { style } = useRouter().query as { style: string }
  const formattedStyle = getCapitalizedSEONameOfStyle(style)

  useOnUnloadTimeOnPage()
  return (
    <>
      <SEOTitle
        title={`${formattedStyle} Reference & Citation Generator | Cite This For Me`}
      />
      {!isLvp && (
        <TopContentWrapper>
          <SourceTypeSelectionTop {...ssrProps} showSubHeaderText />
        </TopContentWrapper>
      )}
      <SourceTypeSelection
        styleId={getActualStyleId(style)}
        initialUrlStyleName={ssrProps.initialUrlStyleName}
        copy={{
          upgradeCopy: flankerDesignUpgradeCopy,
          considerCredibility: sourcePageCredibility,
        }}
      />
    </>
  )
}

SourceSelectionPage.getPageLayout = (page, ssrProps) =>
  getLvpLayout(page, () => <SourceTypeSelectionTop {...ssrProps} showSubHeaderText />)

export const getServerSideProps = async ({ query }: NextPageContext) => {
  const { style } = query as { style: string }
  const [initialUrlStyleName] = await getUrlStyleNameV2(style)
  return {
    props: {
      initialUrlStyleName,
      isDefaultStyle: getActualStyleId(style) === Config.currentStyle,
    },
    notFound: isStyleIdInValid(style),
  }
}
const mapStateToProps = (state: AppState) => ({
  isLvp: lvpLayoutSelector(state),
})
export default connect(mapStateToProps)(SourceSelectionPage)
